<div class="flex flex-col pb-6">
	<div
		class="flex justify-between border-b border-b-gray-200 pt-6 pb-4 items-center"
	>
		<h1 class="text-2xl font-medium m-0 pl-6 mr-6">
			How to Access Your Closer Business Settings
		</h1>
		<ui-button
			class="pr-6 ml-6"
			icon="x"
			preset="ICON_DEFAULT"
			(click)="closeDialog()"
		/>
	</div>
	<div class="pt-6 px-6 pb-3">
		<h2 class="text-lg mb-4">Steps</h2>
		<ol class="list-decimal pl-6">
			<li><span class="ml-1">Go to the LEAP Homepage.</span></li>
			<li>
				<span class="ml-1"
					>Click the "Closer" tab to open your business settings.</span
				>
			</li>
			<li>
				<span class="ml-1">Update your business settings as needed.</span>
			</li>
			<li>
				<span class="ml-1"
					>Return to this window to continue working on your matter.</span
				>
			</li>
		</ol>
	</div>
	<div class="flex justify-center">
		<img
			class="w-1/2"
			src="/assets/images/leap/leap-host-closer-tab.png"
			alt=""
		/>
	</div>
</div>
